let date = (w) => {
    w.user = {}
    let url = window.location.search.substring(1);
    let vars = url.split("&");
    vars.forEach((item, index) => {
        if (vars[index].indexOf('=') > 0) {
            let value = vars[index].split('=')
            w.user[value[0]] = decodeURIComponent(value[1])
        }
    })
    var custom = w.user.customparams || "{}";
    var json = decodeURIComponent(custom.replace(/\+/g, "%20").replace(/\\/g, "")) || {};
    w.user['tag'] = JSON.parse(json).tag;
};
export default {
    date,
}